import React, { useEffect, useState } from 'react';
import ReactConfetti from 'react-confetti';

/**
 * VictoryConfetti component for celebrating game victories
 * Uses react-confetti to create celebratory confetti animation
 * Respects user preferences for reduced motion
 */
const VictoryConfetti = ({ isTriggered, onComplete, targetSelector }) => {
  const [showConfetti, setShowConfetti] = useState(false);
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  // Update window size for confetti
  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Calculate confetti source based on target element position
  const calculateConfettiSource = () => {
    if (targetSelector) {
      const element = document.querySelector(targetSelector);
      if (element) {
        const rect = element.getBoundingClientRect();
        // Return the center of the element
        return {
          x: rect.left + rect.width / 2,
          y: rect.top + rect.height / 2,
          w: 0,
          h: 0,
        };
      }
    }
    // Default to center-bottom if no target specified
    return {
      x: windowSize.width / 2,
      y: windowSize.height * 0.7,
      w: 0,
      h: 0,
    };
  };

  // Handle confetti triggering
  useEffect(() => {
    if (isTriggered) {
      // Check if user prefers reduced motion
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReducedMotion) {
        if (onComplete) {
          setTimeout(onComplete, 100);
        }
        return;
      }

      // Small delay to ensure victory message is visible
      setTimeout(() => {
        setShowConfetti(true);
        
        // Call onComplete after confetti animation
        if (onComplete) {
          setTimeout(() => {
            setShowConfetti(false);
            onComplete();
          }, 3000);
        }
      }, 200);
    } else {
      setShowConfetti(false);
    }
  }, [isTriggered, onComplete]);

  if (!showConfetti) {
    return null;
  }

  return (
    <ReactConfetti
      width={windowSize.width}
      height={windowSize.height}
      recycle={false}
      numberOfPieces={100}
      gravity={0.35}
      initialVelocityX={{ min: -15, max: 15 }}
      initialVelocityY={{ min: -25, max: -5 }}
      tweenDuration={150}
      confettiSource={calculateConfettiSource()}
      colors={['#00ADB5', '#EEEEEE', '#00f2ff', '#ffffff', '#7dd3fc']}
      style={{
        position: 'fixed',
        pointerEvents: 'none',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        zIndex: 1000, // Above most content but below modals
      }}
    />
  );
};

export default VictoryConfetti;